import * as React from "react"
import { Canvas, useFrame } from "@react-three/fiber"
import { useIsHost, useMultiplayerState, myPlayer, usePlayersList } from "playroomkit"
import { useGLTF, Shadow, QuadraticBezierLine } from "@react-three/drei"
import { animated, SpringValue, useSpring } from "@react-spring/web"
import { a } from "@react-spring/three"
import "./app.css"
import { useRef, forwardRef } from "react"
import * as THREE from "three"

const initialTimerText = ["Start", "Clicking", "In", "3", "2", "1", "Go!!!"]

function Switch({ x }: { x: SpringValue<number> }) {
  // Hover state
  const [hovered, setHover] = React.useState(false)
  React.useEffect(() => void (document.body.style.cursor = hovered ? "pointer" : "auto"), [hovered])

  // Events
  const onPointerOver = () => setHover(true)
  const onPointerOut = () => setHover(false)
  // Interpolations
  const pZ = x.to([0, 1], [-5, -2])
  const pZN = x.to([0, 1], [2, 5])

  const goat1 = useRef()
  const goat2 = useRef()

  return (
    <group>
      <Cable start={goat1} end={goat2} />

      <group scale={[0.7, 0.7, 0.7]} dispose={null}>
        <a.group position-y={0.85} position-z={pZ} onPointerOver={onPointerOver} onPointerOut={onPointerOut}>
          <Minion ref={goat1} />
          {/* <a.mesh receiveShadow castShadow raycast={meshBounds} rotation-x={rX} onClick={onClick} onPointerOver={onPointerOver} onPointerOut={onPointerOut}>
          <sphereGeometry args={[0.8, 64, 64]} />
          // @ts-ignore
          <a.meshStandardMaterial roughness={0.5} map={texture} />
        </a.mesh> */}
          <Shadow renderOrder={-1000} position={[0, -1, 0]} rotation={[-Math.PI / 2, 0, 0]} scale={1.5} />
        </a.group>

        <a.group position-y={0.85} position-z={pZN} onPointerOver={onPointerOver} onPointerOut={onPointerOut}>
          <Bird ref={goat2} />
          {/* <a.mesh receiveShadow castShadow raycast={meshBounds} rotation-x={rX} onClick={onClick} onPointerOver={onPointerOver} onPointerOut={onPointerOut}>
          <sphereGeometry args={[0.8, 64, 64]} />
          // @ts-ignore
          <a.meshStandardMaterial roughness={0.5} map={texture} />
        </a.mesh> */}
          <Shadow renderOrder={-1000} position={[0, -1, 0]} rotation={[-Math.PI / 2, 0, 0]} scale={1.5} />
        </a.group>
      </group>
    </group>
  )
}

const Bird = forwardRef((props, ref) => {
  // @ts-ignore
  const { nodes, materials } = useGLTF("https://njoereghgbghascplbcs.supabase.co/storage/v1/object/sign/tug-o-war/bird.glb?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ0dWctby13YXIvYmlyZC5nbGIiLCJpYXQiOjE2ODk3MzM3ODIsImV4cCI6MTcyMTI2OTc4Mn0.Mb-9ko9OPIyuQ_Z-2ETLasLu8euY1I0DAmCm6DA65cI&t=2023-07-19T02%3A29%3A42.458Z")

  return (
    // @ts-ignore
    <group ref={ref} {...props} dispose={null} scale={[0.4, 0.4, 0.3]}>
      <a.group>
        <a.mesh geometry={nodes.pCube19_lambert1_0.geometry} material={materials.lambert1} />
      </a.group>
    </group>
  )
})

const Minion = forwardRef((props, ref) => {
  // @ts-ignore
  const { nodes, materials } = useGLTF("https://njoereghgbghascplbcs.supabase.co/storage/v1/object/sign/tug-o-war/goat.glb?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ0dWctby13YXIvZ29hdC5nbGIiLCJpYXQiOjE2ODk3MzM4MTMsImV4cCI6MTcyMTI2OTgxM30.mq1uzURreB0UGhHMUDtOuqhxjVwagJcxT6qqH9KrbdY&t=2023-07-19T02%3A30%3A13.268Z")

  return (
    // @ts-ignore
    <a.group ref={ref} {...props} dispose={null}>
      <a.mesh castShadow receiveShadow geometry={nodes.pCube9_phong65_0.geometry} material={materials.phong65} />
      <a.mesh castShadow receiveShadow geometry={nodes.pCube9_phong66_0.geometry} material={materials.phong66} />
      <a.mesh castShadow receiveShadow geometry={nodes.pCube9_phong67_0.geometry} material={materials.phong67} />
      <a.mesh castShadow receiveShadow geometry={nodes.pCube9_phong68_0.geometry} material={materials.phong68} />
      <a.mesh castShadow receiveShadow geometry={nodes.pCube9_phong69_0.geometry} material={materials.phong69} />
    </a.group>
  )
})

function Cable({ start, end, v1 = new THREE.Vector3(), v2 = new THREE.Vector3() }) {
  const ref = useRef()
  // @ts-ignore
  useFrame(() => ref.current.setPoints(start.current.getWorldPosition(v1), end.current.getWorldPosition(v2)), [])
  // @ts-ignore
  return <QuadraticBezierLine ref={ref} lineWidth={5} color="#ff2060" />
}

export default function App() {
  const [tapCounterLocal, setTapCounterLocal] = React.useState(0)

  const isHost = useIsHost()
  const players = usePlayersList(true)
  const [finalScore, setFinalScore] = useMultiplayerState("score", 50)
  const [initialTimer, setInitialTimer] = React.useState(0)
  const [wait, setWait] = React.useState(true)
  const [isWinnerFound, setIsWinnerFound] = React.useState(false)

  const previousPlayer1ID = React.useRef(0)
  const previousPlayer2ID = React.useRef(0)

  const lastScore = React.useRef(50)

  const handleTap = () => {
    if (players.length === 2 && !isWinnerFound) {
      setTapCounterLocal((taps) => taps + 1)
    }
  }

  React.useEffect(() => {
    if (wait && players.length === 2) {
      setWait(false)
    }
  }, [players, wait])

  React.useEffect(() => {
    if (!isWinnerFound && (finalScore === 0 || finalScore === 100)) {
      setIsWinnerFound(true)
    }
  }, [finalScore, isWinnerFound])

  const postCounterValue = () => {
    if (players.length === 2) {
      setTapCounterLocal((taps) => {
        // return to server;
        const me = myPlayer()
        me.setState("tapCounter", { taps, id: Date.now() })
        return 0
      })
    }
  }

  React.useEffect(() => {
    if (isHost && players.length === 2) {
      const player1ID = players[0].state?.tapCounter?.id
      const player2ID = players[1].state?.tapCounter?.id
      const [player1Taps = 0, player2Taps = 0] = players.map((player) => player.state.tapCounter?.taps)
      if (player1ID && player2ID && player1ID !== previousPlayer1ID.current && player2ID !== previousPlayer2ID.current) {
        previousPlayer1ID.current = player1ID
        previousPlayer2ID.current = player2ID
        if (player1Taps !== player2Taps) {
          if (player1Taps > player2Taps) {
            setFinalScore(Math.min(finalScore + 10, 100))
          } else {
            setFinalScore(Math.max(finalScore - 10, 0))
          }
        }
      }
    }
  }, [players])

  React.useEffect(() => {
    let interval
    if (initialTimer > initialTimerText.length - 1) {
      interval = setInterval(() => postCounterValue(), 200)
    }
    return () => {
      clearInterval(interval)
    }
  }, [initialTimer])

  React.useEffect(() => {
    let interval
    if (!wait && initialTimer < initialTimerText.length) {
      interval = setInterval(() => setInitialTimer((timer) => timer + 1), 700)
    }
    return () => {
      clearInterval(interval)
    }
  }, [initialTimer, wait])

  React.useEffect(() => {
    if (initialTimer > initialTimerText.length - 1) {
      window.addEventListener("click", handleTap)
    }
    return () => {
      window.removeEventListener("click", handleTap)
    }
  }, [initialTimer])

  const myScore = () => {
    if (isHost) {
      return finalScore
    } else {
      return Math.abs(100 - finalScore)
    }
  }

  // Set up a shared spring which simply animates the toggle above
  // We use this spring to interpolate all the colors, position and rotations
  const [{ x }] = useSpring({ x: finalScore / 100 || 0, config: { mass: 5, tension: 300, friction: 55, precision: 0.0001 } }, [finalScore])

  const time = useSpring({ from: { val: lastScore.current }, to: { val: myScore() }, config: { mass: 5, tension: 500, friction: 70, precision: 0.0001 } })
  lastScore.current = myScore()

  const color = x.to([0, 1], ["#7fffd4", "#c72f46"])

  return (
    <>
      <animated.div className="container" style={{ backgroundColor: x.to([0, 1], ["#c9ffed", "#ff2558"]), color: x.to([0, 1], ["#7fffd4", "#c70f46"]) }}>
        <h1 className="open">{`<${!isHost ? "U" : players?.[1]?.state?.profile?.name?.slice(0, 3) || "P2"}>`}</h1>
        <h1 className="close">{`<${isHost ? "U" : players?.[0]?.state?.profile?.name?.slice(0, 3) || "P1"}>`}</h1>
        {!isWinnerFound && wait && <animated.h1 className="waiting">Waiting for another player</animated.h1>}
        {!isWinnerFound && !wait && initialTimer < 3 && <animated.h1 className="pretext">{initialTimerText?.[initialTimer]}</animated.h1>}
        {!isWinnerFound && !wait && initialTimer > 2 && (
          <animated.h1 className="score">
            {initialTimer < initialTimerText.length
              ? initialTimerText?.[initialTimer]
              : time.val.interpolate((val) => {
                  if (val < 0) return 0
                  else if (val > 100) return 100
                  else return Math.floor(val)
                })}
          </animated.h1>
        )}
        {isWinnerFound && <animated.h1 className="virdict">{`You ${myScore() === 100 ? 'Won' : 'Lost'}`}</animated.h1>}
        <Canvas orthographic shadows dpr={[1, 2]} camera={{ zoom: 60, position: [-10, 10, 10], fov: 35 }}>
          <directionalLight position={[-20, 20, 20]} intensity={1} />
          <a.directionalLight position={[-20, -20, -20]} intensity={0.5} color={color} />
          <a.pointLight position={[0, 0, 5]} distance={10} intensity={5} color={color} />
          <a.spotLight color={color} position={[10, 20, 20]} angle={0.1} intensity={2} shadow-mapSize-width={2048} shadow-mapSize-height={2048} shadow-bias={-0.00001} castShadow />
          <React.Suspense fallback={null}>
            <Switch x={x} />
          </React.Suspense>
        </Canvas>
      </animated.div>
    </>
  )
}
